/* tslint:disable */
/* eslint-disable */
/**
 * RateRelief API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  Tier2ServiceCompleteResponse,
  Tier2ServiceDeclineResponse,
  Tier2ServiceGetResponse,
  Tier2ServiceRaiseResponse,
} from '../models/index';
import {
    Tier2ServiceCompleteResponseFromJSON,
    Tier2ServiceCompleteResponseToJSON,
    Tier2ServiceDeclineResponseFromJSON,
    Tier2ServiceDeclineResponseToJSON,
    Tier2ServiceGetResponseFromJSON,
    Tier2ServiceGetResponseToJSON,
    Tier2ServiceRaiseResponseFromJSON,
    Tier2ServiceRaiseResponseToJSON,
} from '../models/index';

export interface Tier2ApiApiTier2CompletePostRequest {
    timePeriodDate?: Date;
    policyNumber?: string;
    note?: string;
    file?: Blob;
    newRateReliefAmount?: number;
}

export interface Tier2ApiApiTier2DeclinePostRequest {
    timePeriodDate?: Date;
    policyNumber?: string;
    note?: string;
    file?: Blob;
}

export interface Tier2ApiApiTier2GetGetRequest {
    timePeriodDate?: Date;
    policyNumber?: string;
}

export interface Tier2ApiApiTier2RaisePostRequest {
    timePeriodDate?: Date;
    policyNumber?: string;
    note?: string;
    file?: Blob;
}

/**
 * 
 */
export class Tier2Api extends runtime.BaseAPI {

    /**
     */
    async apiTier2CompletePostRaw(requestParameters: Tier2ApiApiTier2CompletePostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Tier2ServiceCompleteResponse>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const consumes: runtime.Consume[] = [
            { contentType: 'multipart/form-data' },
        ];
        // @ts-ignore: canConsumeForm may be unused
        const canConsumeForm = runtime.canConsumeForm(consumes);

        let formParams: { append(param: string, value: any): any };
        let useForm = false;
        // use FormData to transmit files using content-type "multipart/form-data"
        useForm = canConsumeForm;
        if (useForm) {
            formParams = new FormData();
        } else {
            formParams = new URLSearchParams();
        }

        if (requestParameters['timePeriodDate'] != null) {
            formParams.append('TimePeriodDate', (requestParameters['timePeriodDate'] as any).toISOString());
        }

        if (requestParameters['policyNumber'] != null) {
            formParams.append('PolicyNumber', requestParameters['policyNumber'] as any);
        }

        if (requestParameters['note'] != null) {
            formParams.append('Note', requestParameters['note'] as any);
        }

        if (requestParameters['file'] != null) {
            formParams.append('File', requestParameters['file'] as any);
        }

        if (requestParameters['newRateReliefAmount'] != null) {
            formParams.append('NewRateReliefAmount', requestParameters['newRateReliefAmount'] as any);
        }


        let urlPath = `/api/Tier2/Complete`;

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: formParams,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => Tier2ServiceCompleteResponseFromJSON(jsonValue));
    }

    /**
     */
    async apiTier2CompletePost(requestParameters: Tier2ApiApiTier2CompletePostRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Tier2ServiceCompleteResponse> {
        const response = await this.apiTier2CompletePostRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async apiTier2DeclinePostRaw(requestParameters: Tier2ApiApiTier2DeclinePostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Tier2ServiceDeclineResponse>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const consumes: runtime.Consume[] = [
            { contentType: 'multipart/form-data' },
        ];
        // @ts-ignore: canConsumeForm may be unused
        const canConsumeForm = runtime.canConsumeForm(consumes);

        let formParams: { append(param: string, value: any): any };
        let useForm = false;
        // use FormData to transmit files using content-type "multipart/form-data"
        useForm = canConsumeForm;
        if (useForm) {
            formParams = new FormData();
        } else {
            formParams = new URLSearchParams();
        }

        if (requestParameters['timePeriodDate'] != null) {
            formParams.append('TimePeriodDate', (requestParameters['timePeriodDate'] as any).toISOString());
        }

        if (requestParameters['policyNumber'] != null) {
            formParams.append('PolicyNumber', requestParameters['policyNumber'] as any);
        }

        if (requestParameters['note'] != null) {
            formParams.append('Note', requestParameters['note'] as any);
        }

        if (requestParameters['file'] != null) {
            formParams.append('File', requestParameters['file'] as any);
        }


        let urlPath = `/api/Tier2/Decline`;

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: formParams,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => Tier2ServiceDeclineResponseFromJSON(jsonValue));
    }

    /**
     */
    async apiTier2DeclinePost(requestParameters: Tier2ApiApiTier2DeclinePostRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Tier2ServiceDeclineResponse> {
        const response = await this.apiTier2DeclinePostRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async apiTier2GetGetRaw(requestParameters: Tier2ApiApiTier2GetGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Tier2ServiceGetResponse>> {
        const queryParameters: any = {};

        if (requestParameters['timePeriodDate'] != null) {
            queryParameters['TimePeriodDate'] = (requestParameters['timePeriodDate'] as any).toISOString();
        }

        if (requestParameters['policyNumber'] != null) {
            queryParameters['PolicyNumber'] = requestParameters['policyNumber'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/api/Tier2/Get`;

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => Tier2ServiceGetResponseFromJSON(jsonValue));
    }

    /**
     */
    async apiTier2GetGet(requestParameters: Tier2ApiApiTier2GetGetRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Tier2ServiceGetResponse> {
        const response = await this.apiTier2GetGetRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async apiTier2RaisePostRaw(requestParameters: Tier2ApiApiTier2RaisePostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Tier2ServiceRaiseResponse>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const consumes: runtime.Consume[] = [
            { contentType: 'multipart/form-data' },
        ];
        // @ts-ignore: canConsumeForm may be unused
        const canConsumeForm = runtime.canConsumeForm(consumes);

        let formParams: { append(param: string, value: any): any };
        let useForm = false;
        // use FormData to transmit files using content-type "multipart/form-data"
        useForm = canConsumeForm;
        if (useForm) {
            formParams = new FormData();
        } else {
            formParams = new URLSearchParams();
        }

        if (requestParameters['timePeriodDate'] != null) {
            formParams.append('TimePeriodDate', (requestParameters['timePeriodDate'] as any).toISOString());
        }

        if (requestParameters['policyNumber'] != null) {
            formParams.append('PolicyNumber', requestParameters['policyNumber'] as any);
        }

        if (requestParameters['note'] != null) {
            formParams.append('Note', requestParameters['note'] as any);
        }

        if (requestParameters['file'] != null) {
            formParams.append('File', requestParameters['file'] as any);
        }


        let urlPath = `/api/Tier2/Raise`;

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: formParams,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => Tier2ServiceRaiseResponseFromJSON(jsonValue));
    }

    /**
     */
    async apiTier2RaisePost(requestParameters: Tier2ApiApiTier2RaisePostRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Tier2ServiceRaiseResponse> {
        const response = await this.apiTier2RaisePostRaw(requestParameters, initOverrides);
        return await response.value();
    }

}
